export default {
    "navigation": {
        "allWatchfaces": "Tutte le app",
        "faq": "FAQ",
        "helpCenter": "Aiuto e istruzioni",
        "newsletter": "Newsletter",
        "contact": "Contatto",
        "weatherProvider": "Fornitore Meteo",
        "tides": "Maree",
        "colors": "Colori",
        "fonts": "Caratteri"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "App Garmin moderne con funzionalità avanzate per tutte le tue attività",
        "newBadge": "Nuovo",
        "filter": {
            "label": "Product filter",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "All",
            "noProducts": "No products in this category"
        }
    },
    "faq": {
        "title": "Domande frequenti",
        "subtitle": "Trova risposte alle domande comuni sui nostri watchface",
        "tabs": {
            "search": "Cerca",
            "categories": "Categorie",
            "trending": "Tendenze"
        },
        "search": {
            "placeholder": "Cerca aiuto...",
            "button": "Cerca",
            "suggestions": "Ricerche popolari",
            "tips": {
                "title": "Suggerimenti di ricerca",
                "keywords": "Usa parole chiave specifiche come \"GPS\", \"meteo\" o \"impostazioni\"",
                "language": "La ricerca funziona nella tua lingua selezionata",
                "categories": "Sfoglia le categorie per aiuto organizzato"
            }
        },
        "noResults": {
            "title": "Nessun risultato trovato",
            "description": "Prova parole chiave diverse o sfoglia le categorie",
            "browseCategories": "Sfoglia categorie"
        },
        "suggestions": {
            "title": "Ricerche popolari"
        },
        "trending": {
            "title": "Ricerche di tendenza"
        },
        "categories": {
            "title": "Sfoglia per categoria",
            "items": "elementi",
            "allItems": "Tutti gli elementi FAQ",
            "allItemsDescription": "Sfoglia tutte le domande frequenti",
            "noItems": {
                "title": "Nessun elemento in questa categoria",
                "description": "Prova a selezionare una categoria diversa"
            },
            "viewMore": "Visualizza tutti gli elementi"
        },
        "results": {
            "title": "Risultati di ricerca",
            "found": "risultati trovati per",
            "total": "Totale risultati",
            "bestMatch": "Migliore corrispondenza",
            "categories": "Categorie",
            "sortBy": "Ordina per",
            "sort": {
                "relevance": "Rilevanza",
                "priority": "Priorità",
                "category": "Categoria"
            },
            "lastUpdated": "Ultimo aggiornamento",
            "matchedIn": "Corrispondenza in",
            "footer": "Non hai trovato quello che cercavi?",
            "browseCategories": "Sfoglia categorie",
            "viewTrending": "Visualizza tendenze",
            "contactSupport": "Contatta supporto"
        },
        "actions": {
            "copy": "Copia",
            "share": "Condividi",
            "copyAnswer": "Copia risposta",
            "copyAll": "Copia tutto"
        },
        "loading": "Caricamento FAQ...",
        "error": "Errore di caricamento",
        "retry": "Riprova"
    },
    "guides": {
        "backToHelp": "Indietro",
        "purchase": {
            "title": "Acquisto e installazione",
            "tabs": {
                "installation": "Installazione",
                "versions": "Versioni VX / Elite",
                "troubleshooting": "Risoluzione problemi"
            },
            "installation": {
                "title": "Installa i watchface tramite l'app ConnectIQ",
                "intro": "I watchface possono essere installati sull'orologio tramite l'app Garmin ConnectIQ per Android o iOS.",
                "step1": "Collega l'orologio al telefono via Bluetooth e apri l'app ConnectIQ sul telefono.",
                "step2": "Vai alla pagina del watchface che vuoi installare.",
                "step3": "Tocca il pulsante \"Installa\". Il watchface verrà messo in coda e installato sull'orologio.",
                "step4": "Dopo l'installazione vedrai un messaggio nell'app o sull'orologio e il watchface sarà disponibile sul dispositivo.",
                "noteScreen": "Assicurati che lo schermo del telefono non si spenga e che l'app ConnectIQ resti aperta durante installazione e aggiornamenti.",
                "selectWatchfaceTitle": "Selezionare il watchface sull'orologio",
                "selectWatchfaceIntro": "Se il watchface è installato ma non ancora visibile, potrebbe essere necessario selezionarlo nel menu di sistema dell'orologio.",
                "select1": "Premi e tieni il pulsante menu sull'orologio (o il pulsante corrispondente sui dispositivi touch) per aprire il menu di sistema.",
                "select2": "Vai alla voce \"Quadranti\" o \"Design display\".",
                "select3": "Vedrai l'elenco di tutti i watchface installati. Usa i pulsanti su/giù o il touchscreen per navigare.",
                "select4": "Conferma il watchface selezionato con il pulsante in alto a destra. Il watchface è ora attivo sull'orologio."
            },
            "versions": {
                "title": "VX vs Elite – qual è la differenza?",
                "sameFeatures": "Tecnicamente entrambe le versioni sono identiche e offrono le stesse funzioni. L'unica differenza è come si acquistano e si attivano.",
                "eliteTitle": "Versione Elite (Garmin Pay)",
                "elite1": "Installazione separata del watchface acquistato direttamente tramite Garmin Pay nello Store ConnectIQ.",
                "elite2": "La versione Elite è legata al tuo account Garmin. Se compri un orologio nuovo, puoi reinstallare il watchface Elite senza una chiave aggiuntiva.",
                "elite3": "Garmin Pay non è supportato su tutti i modelli e potrebbe non essere disponibile in tutti i paesi.",
                "eliteNoKey": "Importante: acquistando una versione Elite tramite Garmin Pay non viene inviato alcun codice di sblocco. La versione Elite viene sbloccata direttamente dopo l'acquisto e non richiede un codice.",
                "vxTitle": "Versione VX / Sito web",
                "vx1": "Compatibile con un numero maggiore di dispositivi e spesso disponibile anche quando Garmin Pay non lo è.",
                "vx2": "Include un periodo di prova gratuito di alcuni giorni.",
                "vx3": "Dopo la prova puoi acquistare un codice di sblocco su questo sito per sbloccare definitivamente la versione VX (o le sue funzioni pro).",
                "vx4": "Il codice di sblocco è valido solo per il dispositivo per cui è stato acquistato (WatchfaceID).",
                "vx5": "Se l'orologio viene sostituito da Garmin in garanzia, può essere generata una nuova chiave. In tal caso contatta il supporto tramite il modulo di contatto."
            },
            "website": {
                "title": "Acquisto tramite sito web (versioni VX / normali)",
                "step1": "Installa prima il watchface sull'orologio (vedi scheda Installazione). Il WatchfaceID appare nelle impostazioni del watchface solo dopo l'installazione.",
                "step2": "Apri le impostazioni del watchface (tramite app ConnectIQ o Garmin Express) e copia il WatchfaceID dal campo in alto.",
                "step3": "Su questo sito seleziona il watchface corrispondente e inserisci il tuo WatchfaceID nel modulo d'acquisto.",
                "step4": "Completa il pagamento. Riceverai il codice di sblocco via email e potrai inserirlo nel campo chiave delle impostazioni del watchface.",
                "noteNoAutoInstall": "Importante: l'acquisto di un codice di sblocco tramite il sito non installa automaticamente il watchface sull'orologio. I passaggi di installazione sopra vanno completati manualmente."
            },
            "troubleshooting": {
                "installationTitle": "Problemi di installazione (coda / aggiornamenti bloccati)",
                "installationIntro": "A volte l'installazione fallisce, il watchface resta in coda a lungo o l'app ConnectIQ segnala aggiornamenti infiniti.",
                "installationCause": "Di solito dipende dall'app ConnectIQ o dai servizi Garmin, non dal watchface.",
                "installationFix1": "Riavvia l'orologio e riavvia l'app ConnectIQ sul telefono.",
                "installationFix2": "Riprova l'installazione e assicurati che lo schermo del telefono non si spenga e che l'app ConnectIQ resti aperta durante il processo.",
                "garminPayTitle": "Acquisto Garmin Pay bloccato \"in corso\"",
                "garminPayText": "Se un acquisto Garmin Pay nello Store ConnectIQ resta a lungo \"in corso\", la gestione è interamente di Garmin. Come sviluppatori non abbiamo alcun controllo sul sistema Garmin Pay. In tal caso contatta il supporto ufficiale Garmin.",
                "noKeyTitle": "Non ho ricevuto la chiave di sblocco dopo l'acquisto sul sito",
                "noKey1": "Controlla prima la cartella spam della posta. Le email con le chiavi finiscono spesso lì.",
                "noKey2": "Spesso un errore nell'indirizzo email impedisce la consegna. Se non trovi l'email, contattaci.",
                "noKey3": "e indica l'indirizzo email usato per il pagamento e, se possibile, il WatchfaceID.",
                "noKeyElite": "Nota: acquistando una versione Elite direttamente tramite Garmin Pay nello Store ConnectIQ non viene inviato alcun codice di sblocco. La versione Elite viene sbloccata subito dopo l'acquisto e non richiede un codice."
            },
            "contactLink": "Modulo di contatto"
        },
        "timezones": {
            "title": "Fusi orari e offset UTC",
            "basicsTitle": "Cosa sono il 2° e il 3° fuso orario?",
            "basicsText": "In molti watchface puoi impostare due fusi orari aggiuntivi. Di solito si chiamano \"Secondo fuso orario\" e \"Terzo fuso orario\" e sono mostrati in campi dedicati sul quadrante.",
            "offsetTitle": "Impostazione degli offset UTC",
            "offsetIntro": "Nelle impostazioni del watchface c'è di solito un campo in cui puoi inserire gli offset del secondo e terzo fuso orario in minuti rispetto all'UTC.",
            "offsetFormat": "Il primo valore è l'offset del secondo fuso, il secondo è l'offset del terzo. I valori sono in minuti, separati da uno spazio. Il segno + non viene aggiunto automaticamente, quindi i valori positivi vanno inseriti senza +.",
            "exampleLabel": "Esempio:",
            "exampleExplanation": "Qui il secondo fuso usa un offset di -4,5 ore (−270 minuti) e il terzo di +2 ore (+120 minuti), sempre rispetto all'UTC.",
            "changeExample": "Se vuoi impostare il secondo fuso a +6 ore, il primo valore deve essere 360 (6 × 60). Con l'esempio sopra risulterebbe:",
            "advancedTitle": "Opzioni avanzate (suffisso A/B/C)",
            "advancedOptionalHint": "Questa sezione è facoltativa. Rilevante solo se il tuo watchface supporta i suffissi A/B/C.",
            "advancedIntro": "Se il watchface supporta questi suffissi è indicato nella descrizione sopra il campo offset nelle impostazioni del watchface. In tal caso potresti vedere una descrizione simile a:",
            "advancedExample": "Offset UTC 2° e 3° fuso in minuti (separati da spazio) (lettere dopo gli offset: A - formato 12h, B - formato 24h, C - formato militare, vuoto - standard)",
            "advancedNote": "Queste lettere opzionali (A/B/C) controllano il formato di visualizzazione del rispettivo fuso in alcuni watchface. Usale solo se la descrizione del watchface le menziona.",
            "exampleSectionTitle": "Passo per passo: Esempio per diverse città e formati",
            "exampleIntro": "L'esempio seguente mostra come impostare una 2ª zona (es. New York) e una 3ª (es. Tokyo), e opzionalmente 12h o 24h per ciascuna.",
            "exampleStep1Title": "Passo 1: Offset UTC per la 2ª zona",
            "exampleStep1Text": "Scegli città o regione per la 2ª zona. Converti la differenza oraria rispetto all'UTC in minuti. Es.: New York (EST, UTC−5) → −300 minuti. Inserisci questo valore per primo nel campo.",
            "exampleStep2Title": "Passo 2: Offset UTC per la 3ª zona",
            "exampleStep2Text": "Lo stesso per la 3ª zona. Es.: Tokyo (JST, UTC+9) → 540 minuti. È il secondo valore, separato da uno spazio dal primo.",
            "exampleOnlyOffsets": "Se il watchface non usa i suffissi A/B/C, hai finito. Inserisci:",
            "exampleStep3Title": "Passo 3: Suffisso formato opzionale (A/B/C)",
            "exampleStep3Optional": "Questo passo è opzionale: puoi omettere i suffissi anche se il watchface li supporta; si userà il formato predefinito. Per forzare 12h, 24h o militare per zona, aggiungi la lettera subito dopo l'offset, senza spazio.",
            "exampleStep3Text": "Esempio: formato 12h per New York (A) e 24h per Tokyo (B):",
            "exampleStep3Note": "Nessun suffisso = formato predefinito del watchface (spesso 24h). Se i suffissi sono supportati è indicato nella descrizione sopra il campo offset nelle impostazioni.",
            "exampleFormatTitle": "Come viene mostrata l'ora con A, B, C",
            "exampleFormatIntro": "Per lo stesso istante, la visualizzazione cambia per formato (es.: 2ª zona New York -300, 3ª zona Tokyo 540). Anteprima in tempo reale:",
            "zone2": "2ª zona",
            "zone3": "3ª zona",
            "exampleTableTitle": "Riferimento: Offset UTC per alcune città (minuti)",
            "exampleTableIntro": "Ora solare; l'ora legale può variare. Moltiplica le ore per 60."
        },
        "switchViews": {
            "title": "Viste alternative e controllo con gesti",
            "wordLabel": "vista alternativa",
            "basicsTitle": "Cosa sono le viste alternative?",
            "basicsText": "Molti watchface possono mostrare informazioni diverse nella stessa area dello schermo. Queste pagine alternative sono spesso chiamate \"Switchview\" ({{wordLabel}}), \"Switchview 2\", \"Vista superiore 1/2\", \"Vista inferiore 1/2\" o simile nelle impostazioni.",
            "proNote": "Spesso queste viste aggiuntive sono funzioni pro disponibili in prova e richiedono una chiave di attivazione dopo.",
            "gestureTitle": "Cambiare vista con un gesto del polso",
            "gestureIntro": "Sugli orologi senza touchscreen compatibile le viste alternative si possono cambiare con un secondo movimento del polso.",
            "gestureStep1": "Alza il polso come al solito per svegliare il display. I secondi o lo schermo illuminato indicano che l'orologio è in modalità attiva.",
            "gestureStep2": "Entro pochi secondi (circa 7), esegui di nuovo il movimento del polso – non troppo brusco, ma abbastanza chiaro perché l'orologio lo riconosca.",
            "gestureStep3": "Se il watchface supporta le viste alternative, le aree configurate (es. vista superiore o inferiore) passeranno alla pagina successiva.",
            "gestureHint": "Se non cambia nulla, controlla le impostazioni: alcune viste vanno assegnate esplicitamente (es. \"Vista superiore 2\" / \"Vista inferiore 2\").",
            "touchTitle": "Viste alternative su dispositivi con touchscreen",
            "touchIntro": "Sugli orologi più recenti con touchscreen compatibile (es. Fenix 7 e successivi) le viste si possono spesso cambiare anche toccando zone specifiche.",
            "touchConfig": "In molti watchface puoi configurare queste zone nelle impostazioni, spesso più in basso. Esempi tipici sono le cifre delle ore e dei minuti o aree separate sul display.",
            "touchHold": "Se una zona touch è configurata, un tocco prolungato sulla cifra/area corrispondente cambia la vista assegnata.",
            "touchMultiple": "Alcuni watchface offrono più zone assegnabili separatamente – ad es. una per la vista superiore e una per quella inferiore.",
            "touchInfo": "Se per un watchface esistono zone speciali, sono di solito descritte nel testo informativo sul sito o nello Store ConnectIQ."
        },
        "findWfId": {
            "title": "Come trovare il tuo WatchfaceID",
            "whatIs": "Cos'è il WatchfaceID?",
            "whatIsExplanation": "Ogni watchface ha un WatchfaceID univoco per dispositivo. È un numero di 5-6 cifre. Serve per acquistare un codice di attivazione o per il supporto.",
            "connectIqTitle": "Tramite app ConnectIQ (consigliato)",
            "ciq1": "Assicurati che l'orologio sia collegato al telefono via Bluetooth.",
            "ciq2": "Apri l'app ConnectIQ sul telefono.",
            "ciq3": "Vai alla pagina del watchface dove vedi descrizione e immagini. Se non la trovi, usa la barra \"Cerca\" in basso o sotto \"I miei quadranti\" nella sezione \"Dispositivo\".",
            "ciq4": "Premi il pulsante \"Impostazioni\" nella pagina del watchface per aprire tutte le impostazioni.",
            "ciq5": "Il WatchfaceID è nel campo in alto. Copia o digita questo numero: è l'ID richiesto per il pagamento.",
            "keyEntryTitle": "Inserimento della chiave di attivazione",
            "keyEntryExplanation": "Sotto il campo WatchfaceID trovi il campo per la chiave/codice inviato dopo il pagamento. Alcuni watchface mostrano lì i giorni di prova rimanenti – cancellali prima di inserire la chiave.",
            "garminExpressTitle": "Tramite Garmin Express (desktop)",
            "ge1": "Installa Garmin Express e collega l'orologio al computer.",
            "ge2": "Vai all'elenco dei watchface installati.",
            "ge3": "Clicca il pulsante con i tre puntini accanto al watchface per aprire le impostazioni.",
            "ge4": "Segui gli stessi passaggi dell'app ConnectIQ.",
            "geNote": "Nota: si consiglia l'app ConnectIQ, perché alcune versioni di Garmin Express possono dare errori.",
            "zeroId": "Il WatchfaceID mostra 0?",
            "zeroIdExplanation": "A volte il WatchfaceID mostra 0. Di solito si risolve salvando le impostazioni una volta o riavviando l'orologio. Se continua a mostrare 0, dovrebbe comunque funzionare per il pagamento."
        },
        "location": {
            "title": "Configurazione GPS e posizione",
            "whatIsGpsFix": "Cos'è un fix GPS?",
            "gpsFixExplanation": "Un fix GPS indica al watchface dove sei, così può calcolare correttamente alba/tramonto, fasi lunari, posizione meteo e maree.",
            "howTo": "Come fare un fix GPS",
            "step1": "Sull'orologio vai alla schermata di avvio di un'attività (es. \"Corsa\")",
            "step2": "Attendi che l'orologio acquisisca il segnale GPS (barra/icona verde)",
            "step3": "Torna al quadrante: i dati dovrebbero aggiornarsi in pochi minuti",
            "alternative": "Alternativa: GPS del telefono",
            "alternativeExplanation": "Puoi attivare il GPS anche sul telefono. L'orologio deve essere collegato via Bluetooth. È più lento ma funziona ugualmente.",
            "requirements": "Requisiti",
            "req1": "Orologio collegato al telefono via Bluetooth",
            "req2": "App Garmin Connect (non ConnectIQ) almeno in background",
            "req3": "GPS attivo sul telefono per la posizione da telefono"
        },
        "settings": {
            "tabs": { "options": "Opzioni campi dati", "change": "Modifica impostazioni", "troubleshoot": "Risoluzione problemi" },
            "title": "Impostazioni watchface",
            "optionsIntro": "Elenco generale di tutte le opzioni per i campi dati. Clicca per la descrizione. Non tutte le opzioni sono disponibili su tutti i watchface.",
            "change": {
                "title": "Come modificare le impostazioni del watchface",
                "intro": "Le impostazioni del watchface si modificano dall'app ConnectIQ sul telefono.",
                "step1": "Collega l'orologio al telefono via Bluetooth e apri l'app ConnectIQ (non Connect).",
                "step2": "Vai alla pagina del watchface. Se non è installato, installalo prima.",
                "step3": "Nella pagina del watchface troverai il pulsante \"Impostazioni\": toccalo per aprire l'elenco.",
                "step4": "Qui puoi modificare campi dati, colori e opzioni avanzate.",
                "step5": "Tocca il pulsante Salva in alto a destra per trasferire le impostazioni sull'orologio.",
                "installLink": "Guida all'installazione"
            },
            "troubleshoot": {
                "title": "Risoluzione problemi",
                "cantSave": { "q": "Le impostazioni non si salvano", "a1": "A volte i server Garmin hanno problemi con alcuni caratteri.", "a2": "Svuota il campo del tema colore (se presente) e salva di nuovo." },
                "wontOpen": { "q": "Le impostazioni non si aprono", "a1": "Chiudi completamente l'app ConnectIQ e riavvia l'orologio se necessario.", "a2": "Se vedi solo il pulsante \"Installa\", il watchface non è ancora installato." },
                "missingOptions": { "q": "Non trovo un'opzione di impostazione", "a": "Non tutte le opzioni sono disponibili su tutti i dispositivi." },
                "naValue": { "q": "Un campo mostra solo \"n/a\"", "a": "Il dispositivo non supporta questa opzione (modello vecchio o hardware mancante)." }
            }
        },
        "dateFormat": {
            "title": "Formato data personalizzato (Data 1 / 2 / 3)",
            "basicsTitle": "A cosa servono i campi formato data?",
            "basicsIntro": "Nelle impostazioni del watchface ci sono due campi (o tre) per configurare come vengono mostrate Data 1, Data 2 e eventualmente Data 3. Le lettere che inserisci definiscono il formato.",
            "notAll": "Non disponibile su tutti i watchface.",
            "where": "I campi si trovano in genere più in basso nelle impostazioni, sotto le opzioni campi dati.",
            "codesTitle": "Codici di formato",
            "codesIntro": "Puoi usare le seguenti lettere. Il risultato riflette la data attuale.",
            "codeD": "giorno del mese (con zero iniziale)",
            "codeDText": "giorno in testo (es. lunedì)",
            "codeM": "mese in numero (con zero iniziale)",
            "codeMText": "mese in testo",
            "codeY": "anno due cifre",
            "codeY4": "anno quattro cifre",
            "codeJ": "data giuliana (militare)",
            "codeW": "numero settimana",
            "codeO": "mese senza zero iniziale",
            "codeN": "giorno senza zero iniziale",
            "codeP": "giorno dell'anno",
            "exampleHint": "Es.: \"D, d.M.Y\" può mostrare \"Lun, 27.02.2026\"."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "Come funzionano i temi?:",
            "description": "In cima alle impostazioni del watchface hai una \"stringa tema\" che rappresenta le impostazioni colore attuali (icone, grafici, ora, ecc.). Se modifichi qualcosa (es. colore della sezione superiore) e premi \"Salva\", la stringa tema si aggiorna la prossima volta che apri le impostazioni. Così puoi salvare le impostazioni colore copiando e conservando la stringa altrove. Puoi condividerla con altri (es. nelle recensioni/forum) e applicare le stringhe di altri per provare altri stili."
        },
        "dynamicThemeSwitching": {
            "title": "Cambio tema dinamico:",
            "sunset": {
                "title": "Cambio dopo il tramonto / prima dell'alba -",
                "description": "se metti un punto esclamativo ! davanti alla stringa tema che vuoi usare nel campo stringa tema, verrà salvata come tema a cui passare dopo il tramonto (esempio: !UEUE[UEUEEEEEEU^). Puoi cambiarla quando vuoi inserendo una stringa con ! iniziale nel campo. Per eliminare il tema notturno metti solo ! nel campo e non cambierà più."
            },
            "lowPower": {
                "title": "Cambio in risparmio energetico -",
                "description": "stesso procedimento del tema tramonto/alba sopra, ma invece di ! metti un # davanti alla stringa tema (esempio: #UEUE[UEUEEEEEEU^). Ogni orologio entra in \"modalità risparmio energetico\" dopo circa 10 secondi in cui guardi l'orologio o torni da un menu. Di solito i secondi scompaiono in risparmio (si può cambiare nelle impostazioni). Le due opzioni (@notte/@risparmio) si possono combinare. Una volta impostata, una stringa tema dinamica non è visibile nelle impostazioni, quindi conservala altrove se vorrai modificarla in futuro."
            }
        }
    },
    "helpCenter": {
        "title": "Aiuto e istruzioni",
        "subtitle": "Risposte, guide e istruzioni per il tuo watchface",
        "guidesTitle": "Guide e istruzioni",
        "faqTitle": "Domande frequenti",
        "allCategories": "Tutto",
        "guides": "Guide",
        "faqResults": "FAQ",
        "noResults": "Nessun risultato trovato",
        "noResultsHint": "Prova altre parole chiave o sfoglia le categorie e le guide sotto."
    },
    "watchfacesOverview": {
        "title": "Tutte le app",
        "loading": "Caricamento watchfaces...",
        "error": "Errore nel caricamento dei watchfaces",
        "retry": "Riprova",
        "noWatchfaces": "Nessun watchface disponibile"
    },
    "detailTabs": {
        "payment": "Pagamento",
        "themes": "Temi",
        "info": "Info",
        "instructions": "Istruzioni",
        "instructionsIntro": "Tutte le guide e le istruzioni a colpo d'occhio:",
        "noThemes": "Nessun tema colore disponibile per questo watchface."
    },
    "watchfaceDetail": {
        "loading": "Caricamento watchface...",
        "error": {
            "notFound": "Watchface non trovato",
            "loading": "Errore nel caricamento del watchface"
        },
        "backToOverview": "Torna alla panoramica",
        "goToStore": "Vai allo IQ Store",
        "goToTrial": "Versione di prova",
        "devices": "dispositivi",
        "info": {
            "title": "Funzionalità",
            "tides": "🌊 Informazioni sulle maree con aggiornamenti automatici",
            "weather": "🌤️ Dati meteo da OpenWeatherMap e Yr",
            "colors": "🎨 Temi colore e personalizzazioni",
            "location": "📍 Posizione tramite GPS",
            "faq": "❓ FAQ e supporto",
            "weatherFallback": "Senza abbonamento One Call 3.0, la chiave API OpenWeatherMap usa il provider \"Yr\" come fallback."
        }
    },
    "colorThemes": {
        "clickToCopy": "Clicca per copiare",
        "clickToPreview": "Clicca per anteprima",
        "closePreview": "Chiudi anteprima",
        "copied": "Copiato!",
        "useInSettings": "Usalo nelle impostazioni del watchface",
        "guideLink": "Maggiori informazioni su temi e stringhe tema",
        "deviceNote": "I temi colore non sono disponibili su tutti i dispositivi.",
        "noFieldNote": "Se le impostazioni del tuo watchface non hanno un campo separato per i temi colore, questi non sono supportati per il tuo modello di orologio su questo watchface."
    },
    "payment": {
        "option1": {
            "title": "Opzione 1: Garmin Pay",
            "description": "Acquista il watchface a pagamento tramite Garmin Pay su ConnectIQ Store (se il tuo orologio è supportato).",
            "link": "Link al ConnectIQ Store"
        },
        "option2": {
            "title": "Opzione 2: Pagamento diretto con WatchfaceID",
            "description": "Se il tuo orologio non è supportato dalla versione Pro, puoi acquistare una chiave Trial/VX inserendo la tua WatchfaceID.",
            "vxNote": "Questa è una chiave per la versione VX del watchface, non la versione Garmin Pay!",
            "vxLink": "Link alla versione VX"
        },
        "tax": "IVA",
        "wfid": {
            "description": "Inserisci la tua WatchfaceID (nelle impostazioni del watchface)",
            "placeholder": "Inserisci WatchfaceID (5-6 cifre)",
            "guideLink": "Come trovare la tua WatchfaceID",
            "guideLinkShort": "Mostra istruzioni"
        },
        "wfidError": {
            "letters": "La WatchfaceID deve contenere solo numeri",
            "tooLong": "La WatchfaceID deve essere di 5-6 cifre",
            "invalid": "Inserisci una WatchfaceID valida (5-6 cifre)",
            "lengthHint": "Una WatchfaceID è di solito 5-6 cifre. Controlla."
        },
        "errors": {
            "empty": "Inserisci la tua WatchfaceID",
            "invalid": "Inserisci una WatchfaceID valida",
            "config": "Errore di configurazione pagamento",
            "checkout": "Impossibile aprire il pagamento. Riprova."
        },
        "buy": "Acquista ora",
        "selectMethod": "Scegli la tua versione",
        "versionSelectHint": "Queste sono due versioni separate — seleziona quella corretta:",
        "vxWarning": "Le versioni VX ed Elite sono ciascuna versioni scaricabili separatamente del quadrante. Un codice di attivazione per la versione VX NON sblocca la versione Elite.",
        "beta": {
            "title": "Attualmente in beta",
            "description": "Durante questa fase beta puoi usare questo watchface completamente gratis. Non verrà addebitato alcun costo automatico dopo il periodo di prova. In questo periodo vengono testate nuove funzioni e miglioramenti. Grazie per il tuo feedback!",
            "descriptionApp": "Durante questa fase beta puoi usare l’app completamente gratis. Dopo il periodo di prova non ci saranno addebiti automatici. In questa fase vengono testate nuove funzioni e miglioramenti. Grazie per il vostro feedback!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Versione Elite",
            "description": "Questo watchface è disponibile solo tramite Garmin Pay su ConnectIQ Store.",
            "comboDescription": "Acquista tramite Garmin Pay su ConnectIQ Store. Versione separata e autonoma.",
            "compatibility": "Garmin Pay non è supportato su tutti gli orologi. Verifica la compatibilità nella pagina Store. Altrimenti scarica la versione VX (identica).",
            "storeLink": "Apri in ConnectIQ Store",
            "moreGuide": "Serve più su differenza Elite / VX?",
            "moreGuideLink": "Leggi la guida acquisto e installazione",
            "eliteNoKey": "Acquistando una versione Elite tramite Garmin Pay non viene inviato alcun codice di sblocco. La versione Elite è sbloccata direttamente dopo l'acquisto e non richiede codice.",
            "accountBound": "L'acquisto tramite Garmin Pay è legato al tuo account Garmin e disponibile automaticamente per i tuoi futuri dispositivi (se compatibili).",
            "eliteNoKeyAndGuide": "Acquistando tramite Garmin Pay non viene inviato alcun codice — la versione Elite è sbloccata direttamente dopo l'acquisto. Più dettagli nella guida acquisto e installazione."
        },
        "vx": {
            "badge": "Tutti i dispositivi",
            "title": "Versione VX",
            "description": "Compatibile con tutti i dispositivi supportati. Scarica la versione di prova da ConnectIQ Store e attivala qui con un codice acquistato.",
            "trialNote": "La versione VX include un periodo di prova. Poi acquista un codice di attivazione sotto per sbloccarla.",
            "deviceBound": "Un codice di attivazione è legato al tuo dispositivo e sblocca la versione VX in modo permanente.",
            "moreGuide": "Serve più su versione VX, chiavi o installazione?",
            "moreGuideLink": "Leggi la guida acquisto e installazione",
            "downloadLink": "Scarica versione VX",
            "details": {
                "line1": "Dopo il pagamento, la chiave di attivazione verrà inviata all'email che inserirai nel prossimo passo.",
                "line2": "Assicurati che l'indirizzo email sia corretto.",
                "line3": "Controlla la cartella spam dopo il pagamento; le email con le chiavi finiscono spesso lì.",
                "line4": "Tutti i pagamenti sono gestiti da Paddle; nessun account richiesto.",
                "line5": "Per supporto, usa il modulo di contatto o lo strumento ConnectIQ Store.",
                "line6": "Altre richieste non possono essere elaborate."
            }
        },
        "standalone": {
            "title": "Acquista codice di attivazione",
            "description": "Acquista un codice di attivazione inserendo la tua WatchfaceID sotto. Il codice ti verrà inviato subito."
        },
        "checkoutOpening": "Apertura pagamento...",
        "info": {
            "key": "Dopo l'acquisto riceverai una chiave da inserire nelle impostazioni del watchface.",
            "activation": "La chiave si attiva subito dopo il pagamento.",
            "support": "Per domande, contatta il supporto.",
            "moreGuide": "Maggiori informazioni su acquisto e installazione"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Carta di credito"
        }
    },
    "footer": {
        "tagline": "App Garmin moderne con funzionalità avanzate per tutte le attività.",
        "description": "App Garmin moderne con funzionalità avanzate per tutte le attività."
    },
    "newsletter": {
        "title": "Newsletter",
        "description": "Iscriviti alla newsletter per aggiornamenti su nuovi watchface, funzioni e offerte.",
        "frequencyHint": "Circa un'email ogni due mesi. Puoi annullare l'iscrizione in qualsiasi momento.",
        "emailPlaceholder": "Il tuo indirizzo email",
        "subscribe": "Iscriviti",
        "unsubscribe": "Annulla iscrizione",
        "subscribeSuccess": "Iscrizione completata! Controlla la tua email.",
        "subscribeError": "Si è verificato un errore. Riprova più tardi.",
        "unsubscribeSuccess": "Iscrizione annullata.",
        "unsubscribeError": "Si è verificato un errore. Riprova più tardi."
    },
    "contact": {
        "title": "Contatto",
        "description": "Hai una domanda o ti serve supporto? Scrivimi un messaggio.",
        "emailLabel": "E-mail",
        "emailPlaceholder": "tua@email.it",
        "deviceLabel": "Dispositivo (opzionale)",
        "devicePlaceholder": "es. Fenix 7",
        "watchfaceLabel": "Watchface (opzionale)",
        "watchfacePlaceholder": "es. Horizon",
        "messageLabel": "Messaggio",
        "messagePlaceholder": "Il tuo messaggio...",
        "send": "Invia messaggio",
        "sendAnother": "Invia un altro messaggio",
        "successTitle": "Messaggio inviato!",
        "successMessage": "Ti risponderò il prima possibile.",
        "error": "Si è verificato un errore. Riprova oppure scrivi direttamente a dev@orcatec.net.",
        "rateLimit": "Massimo 2 messaggi ogni 5 minuti. Riprova più tardi.",
        "consentNotice": "Inviando il modulo accetti il trattamento dei tuoi dati in conformità con la mia",
        "guidesIntro": "Se hai domande su funzioni specifiche, queste guide potrebbero già contenere la risposta:",
        "faqIntro": "Per molti argomenti esiste anche una FAQ dettagliata:",
        "faqLinkLabel": "Apri Aiuto e istruzioni",
        "responseTimeNotice": "Ti chiedo di avere pazienza: nei periodi più intensi la risposta può richiedere anche alcuni giorni."
    },
    "fonts": {
        "title": "Caratteri",
        "timefonts": "Caratteri ora",
        "datafonts": "Caratteri dati"
    },
    "common": {
        "loading": "Caricamento...",
        "error": "Errore",
        "retry": "Riprova",
        "back": "Indietro",
        "close": "Chiudi",
        "save": "Salva",
        "cancel": "Annulla",
        "confirm": "Conferma",
        "notFound": "404 – Pagina non trovata"
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "L'app Bierwandern ti permette di tracciare la tua escursione e le ricariche che gusti lungo il percorso. In più c'è una stima del tasso alcolico con grafico (stima approssimativa) – ma non prenderla troppo sul serio!",
        "settingsHint": "Nella schermata iniziale, premi il pulsante menu dell'orologio per aprire le impostazioni (sugli orologi con layout a 2 pulsanti, tieni premuto il touchscreen).",
        "disclaimer": "Il calcolo del tasso alcolico è una metrica puramente divertente – un algoritmo che stima l'alcol nel sangue in base alle bevande consumate e al peso corporeo! Non prendere decisioni basandoti su questo valore: non è affidabile e non è una misurazione reale dell'alcol!",
        "closing": "Per il resto, ti auguro buone escursioni e divertimento!",
        "support": "Per problemi o suggerimenti di miglioramento, usa il pulsante «App Support» – grazie."
    },
    "bodysurf": {
        "intro": {
            "title": "Cos'è BodySurf?",
            "text": "BodySurf è un'app Garmin Connect IQ per il bodysurf. Usa il GPS per rilevare quando cavalchi un'onda, misura distanza e durata di ogni ride e assegna un titolo divertente in base alla distanza. Le sessioni vengono salvate come attività con giri singoli in Garmin Connect."
        },
        "gps": {
            "title": "Prima di iniziare – GPS",
            "text1": "Attendi il fix GPS prima di avviare una sessione. Nella schermata iniziale vedrai \"Ricerca GPS\" finché non c'è segnale, poi \"START per iniziare\".",
            "text2": "Per la massima precisione l'app usa GPS multi-GNSS / dual-band se supportato dall'orologio. Resta fermo un momento in acqua se il fix richiede tempo."
        },
        "start": {
            "title": "Schermata di Avvio",
            "startBtn": "Avvia una nuova sessione quando il GPS è pronto (START = inizia sessione).",
            "menuBtn": "Apri impostazioni: Come usare e Unità (MENU = impostazioni / info).",
            "backBtn": "BACK = esci dall'app"
        },
        "during": {
            "title": "Durante l'Attività",
            "detect": "I giri vengono rilevati dal GPS velocità automaticamente. Usa BACK per avviare/arrestare un giro manualmente. Movimenti brevi sotto circa 2 metri vengono scartati.",
            "startBtn": "START = ferma / salva / riprendi",
            "backBtn": "BACK = giro manuale on/off",
            "live": "Durante la ride vedi distanza attuale, titolo live e \"IN CORSO!\". Dopo una ride titolo e statistiche restano visibili fino alla prossima."
        },
        "stop": {
            "title": "Menu stop",
            "resume": "Riprendi",
            "save": "Salva",
            "discard": "Scarta"
        },
        "after": {
            "title": "Dopo la Sessione",
            "summary": "Il riepilogo mostra tempo sessione, numero di Giri, distanza totale e la ride Migliore con titolo e statistiche.",
            "rides": "Scorri per vedere i dettagli del giro. Su orologi a pulsanti: << DOWN rides.",
            "finished": "Poi: Nuova Sessione con START o Esci dall'App con INDIETRO."
        },
        "titles": {
            "title": "Titoli delle ride",
            "intro": "Ogni giro riceve un titolo divertente basato sulla distanza. Più lungo è il giro, migliore è il titolo!",
            "colDistance": "Distanza",
            "colTitle": "Titolo",
            "th0": "Relitto",
            "th1": "Cetriolo",
            "th2": "Passera",
            "th3": "Scacciagabb.",
            "th4": "Sceriffo",
            "th5": "Ispettore",
            "th6": "Cavaliere",
            "th7": "Consulente",
            "th8": "Frangionde",
            "th9": "Aquaman",
            "th10": "Surfista senza tavola",
            "th11": "Leggenda della costa",
            "th12": "Poseidone"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Le sessioni salvate compaiono in Garmin Connect con campi personalizzati: titolo ride, distanza giro (metri), tempo giro (secondi) e ride/tempo più lunghi a livello sessione. Ogni ride rilevata è salvata come giro."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "Su Instinct il sotto-display mostra ora, GPS e distanza. Usa il pulsante GIÙ invece dello swipe (<< DOWN rides).",
            "menu": "\"Menu\" è a sinistra nella schermata iniziale. Premi START quando compare GPS OK nel sotto-display."
        },
        "settings": {
            "title": "Impostazioni",
            "units": "Unità: passa tra metrico e imperiale per distanza e velocità sull'orologio.",
            "info": "Info: guida integrata (Come usare) per i pulsanti durante attività, dopo sessione e schermata iniziale."
        },
        "supportBefore": "Per problemi o suggerimenti usa il",
        "supportLink": "modulo di contatto",
        "supportAfter": " – grazie!"
    }
};
